@if (operationSegmentSpec$ | async; as operationSegmentSpec) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: operationSegmentSpec }"
          >
          </ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: operationSegmentSpec }"
          >
          </ng-template>
        </mat-toolbar>
      }
    </div>
    <elder-single-pane-wrapper class="flex">
      <elder-pane-header>
        <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
        <elder-pane-actions>
          <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
            <mat-icon>save</mat-icon>
          </button>
        </elder-pane-actions>
      </elder-pane-header>
      <elder-pane-content>
        <form #mainFrm="ngForm" class="flex layout-row gap-xl">
          <div class="flex layout-col">
            <!-- Identifications -->
            <elder-pane-subtitle>{{ 'context.identification' | translate }}</elder-pane-subtitle>
            <div class="layout-col gap-md">
              <mat-form-field>
                <elder-select
                  appActionSelect
                  name="addOperation"
                  placeholder="{{ 'process.actions.action' | translate }}"
                  required
                  valueAsId
                  [(value)]="operationSegmentSpec.action"
                >
                  <div *elderSelectValue="let value" class="layout-col">
                    <span style="line-height: 20px">{{ value.name }}</span>
                    <span class="mat-caption">{{ value.id }}</span>
                  </div>
                </elder-select>
              </mat-form-field>
            </div>
          </div>
        </form>
      </elder-pane-content>
    </elder-single-pane-wrapper>
  </div>
}

<ng-template #header let-operationSegmentSpec>
  @if (creationMode) {
    <span>
      {{ 'operations.new' | translate }}
    </span>
  } @else {
    <elder-header
      [header]="'operations.operation' | translate"
      [subheader]="'ID: ' + operationSegmentSpec.action"
    >
    </elder-header>
  }
</ng-template>
